module.exports = __webpack_public_path__ + "./fonts/paradigma-logo.28adb79f22fe3a7da1a362355ccc858d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Pages/Login/paradigma-logo.svg
// module id = ./src/views/Pages/Login/paradigma-logo.svg
// module chunks = 0